<script lang="ts" setup>
import { createErrorMessage } from '@errors/helpers';
import VInfoBox from '@shared/component/VInfoBox/VInfoBox.vue';
import VSkeleton from '@shared/component/VSkeleton/VSkeleton.vue';
import { useQuery } from '@tanstack/vue-query';
import { toRefs } from 'vue';

import FieldRowV2 from '@shared/form/FieldRowV2/FieldRowV2.vue';
import StringField from '@shared/form/StringField/StringField.vue';
import FieldRowGroup from '@shared/form/FieldRowV2/FieldRowGroup.vue';
import VColumn from '@shared/component/VDataTable/VColumn.vue';
import VDataTable from '@shared/component/VDataTable/VDataTable.vue';
import { polisQueries } from '../polisQueries';

const props = defineProps<{
  polisnummer: string;
}>();

const { polisnummer } = toRefs(props);

const { data, isPending, error, isError } = useQuery({
  ...polisQueries.getRoydata(polisnummer),
  select: (res) => res.data,
  staleTime: 60000,
});
</script>
<template>
  <div>
    <VInfoBox badge-text="error" class="mt-4" type="danger" v-if="isError">
      <div v-html="createErrorMessage(error)"></div>
    </VInfoBox>

    <VSkeleton height="lg" :count="12" v-else-if="isPending" />

    <FieldRowGroup v-else :gap="2">
      <FieldRowV2 label="Aantal schadevrije jaren (eigen opgave)">
        <StringField readonly :value="data.schadevrijejarenEigenOpgave" />
      </FieldRowV2>
      <FieldRowV2 label="Bevragingen">
        <VDataTable :value="data.bevragingen" v-if="data.bevragingen.length" borderless>
          <VColumn sortable header="Status" field="status" />
          <VColumn sortable header="Datum" field="datum" />
          <VColumn sortable header="Tijd" field="tijd" />
        </VDataTable>
        <VInfoBox class="w-full" type="info" v-else>Geen bevragingen gevonden.</VInfoBox>
      </FieldRowV2>
      <FieldRowV2 label="In gebruik">
        <StringField readonly :value="data.uitgiftecode" />
      </FieldRowV2>
      <FieldRowV2 label="Aantal schadevrije jaren" v-if="data.schadevrijejaren">
        <StringField readonly :value="data.schadevrijejaren" />
      </FieldRowV2>
      <FieldRowV2 label="Dossiernummer" v-if="data.dossiernummer">
        <StringField readonly :value="data.dossiernummer" />
      </FieldRowV2>
      <FieldRowV2 label="Roy-data ID" v-if="data.roydataId">
        <a href="https://roydata.stichting-eps.nl/royementsgegevens-in-gebruik" target="_new">{{
          data.roydataId
        }}</a>
      </FieldRowV2>
    </FieldRowGroup>
  </div>
</template>
